import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTripDetailBadge = styled.div`
  width: 100px;
  text-align: center;
  line-height: 1;
  color: ${props => props.color ? props.color : null};
`;

const BadgeTitle = styled.p`
  font-weight: 600;
  font-size: 0.7em;
`;

const BadgeSubtitle = styled.p`
  color: ${props => props.color ? props.color : '#7A7A7A'};
  font-size: 0.6em;
  padding: 5px;
`;

function TripDetailBadge(props) {
  return (
    <StyledTripDetailBadge color={props.color}>
        {props.icon}
        <BadgeTitle>{props.title}</BadgeTitle>
        <BadgeSubtitle color={props.color}>{props.subtitle}</BadgeSubtitle>
    </StyledTripDetailBadge>
  );
}

TripDetailBadge.propTypes = {
  icon: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
  color: PropTypes.string,
};


export default TripDetailBadge;
